module.exports = __webpack_public_path__ + "img/chengben2.f0271d28.jpg";